import getI18nProps from '@/utils/i18/getI18nProps';
import React, { useState } from 'react';
import {AllAirdrops,Participated} from '@/components/pages/airdrops';
import { Trans, useTranslation } from 'next-i18next';
import WrappedTabs from '@/components/ui/WrappedTab';
import {
  useMediaQuery,
  Typography,
  Stack,
  Card,
  CardContent,
} from '@mui/material';
import useTheme from '@/theme/useTheme';

const AirdropsPage: React.FC = () => {
  const [t] = useTranslation();
  const [currentTab, setCurrentTab] = useState('crash');
  const { theme } = useTheme();

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setCurrentTab(newValue);
  };
  const TabButtonStyle = {
    borderTopRightRadius: '10px',
    borderTopLeftRadius: '10px',
    borderBottomLeftRadius: '0px',
    borderBottomRightRadius: '0px',
    border: 'none',
    color: '#848E9C',
    bgcolor: 'rgba(132, 142, 156, 0.1)',
    ['&.Mui-selected']: {
      bgcolor: 'rgba(252, 213, 53, 0.1)',
      color: '#F0B90B',
      borderTopRightRadius: theme.shape.borderRadius,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderBottomLeftRadius: '0px',
      borderBottomRightRadius: '0px',
    },
  };
  return (
    <div>
      <Typography variant="h4">Airdrops</Typography>
      <Typography mt={2}>
        Be the first to know about upcoming airdrops here
      </Typography>

      <Typography mt={2}>
        SPACE ID Mission SPACE ID is building a universal name service network
        with a one-stop identity platform to discover, register, trade, manage
        web3 domains. It also includes a Web3 Name SDK & API for developers
        across blockchains and provides a multi-chain name service for everyone
        to easily build and create a web3 identity. The ID Token ID is the
        governance token of SPACE ID. It is designed to play a critical role in
        the decision-making process of the project, allowing users to have a say
        in the direction and future of SPACE ID. The ID token serves as an
        essential part in the growth and sustainability of the SPACE ID
        ecosystem, incentivizing users to engage with the project and contribute
        to its success. With the launch of ID, SPACE ID is poised to become a
        leader in the Web3 industry, providing users with even more well-rounded
        platform for managing their digital identities.
      </Typography>
      <WrappedTabs
        initialTab={'AllAirdrops'}
        onChange={handleTabChange}
        sxs={{
          tabsWrapperSX: {
            marginBottom: 4,
            borderBottom: '2px',
            borderBottomStyle: 'solid',
            borderColor: '#474D57',
          },
          wrapperSX: {
            // background: 'pink',
          },
        }}
      >
        {[
          {
            title: t('All airdrops'),
            name: 'AllAirdrops',
            content: <AllAirdrops />,
            tab: {
              sx: TabButtonStyle,
            },
          },
          {
            title: t('Participated'),
            name: 'Participated',
            tab: {
              sx: TabButtonStyle,
            },
            content: <Participated/>,
          },
        ]}
      </WrappedTabs>
    </div>
  );
};

export async function getServerSideProps({ locale }) {
  return {
    props: {
      ...(await getI18nProps({ locale, additionalNamespaces: ['airdrops'] })),
    },
  };
}

export default AirdropsPage;
